import { validateEnumTranslations } from '../../safety_checks';
import { ProCustomerCustomFieldType } from '../pro-customer-custom-field';

export const PRO_CUSTOMER_CUSTOM_FIELD_TYPE_TRANSLATE_KEY = 'PRO_CUSTOMER_CUSTOM_FIELD_TYPE_';

export const ProCustomerCustomFieldTypeTranslation = {
  'fr-FR': {
    [`${PRO_CUSTOMER_CUSTOM_FIELD_TYPE_TRANSLATE_KEY}${ProCustomerCustomFieldType.TEXT}`]: 'Texte court',
    [`${PRO_CUSTOMER_CUSTOM_FIELD_TYPE_TRANSLATE_KEY}${ProCustomerCustomFieldType.TEXTAREA}`]: 'Texte long',
    [`${PRO_CUSTOMER_CUSTOM_FIELD_TYPE_TRANSLATE_KEY}${ProCustomerCustomFieldType.SELECT}`]: 'Liste déroulante',
    [`${PRO_CUSTOMER_CUSTOM_FIELD_TYPE_TRANSLATE_KEY}${ProCustomerCustomFieldType.NUMBER}`]: 'Nombre',
    [`${PRO_CUSTOMER_CUSTOM_FIELD_TYPE_TRANSLATE_KEY}${ProCustomerCustomFieldType.CHECKBOX}`]: 'Case à cocher',
    [`${PRO_CUSTOMER_CUSTOM_FIELD_TYPE_TRANSLATE_KEY}${ProCustomerCustomFieldType.DATE}`]: 'Date',
  },
};

validateEnumTranslations(
  ProCustomerCustomFieldType,
  ProCustomerCustomFieldTypeTranslation,
  PRO_CUSTOMER_CUSTOM_FIELD_TYPE_TRANSLATE_KEY,
  true,
);
